module.exports = __webpack_public_path__ + "static/media/registp02_zhChs.5cdb0e9a.png";